import { VaultWithdraw } from '@bz/wallet';

export const route: RouteDefinition = {
  preload: () => {},
  info: {
    login: true,
    dialog: {
      get title() {
        return t('Withdraw from Vault');
      },
      class: 'w-[500px] h-[700px]',
    },
  },
};

export default VaultWithdraw;
